module.exports = __webpack_public_path__ + "images/ExternalPromo/lyrics-250-5.png?25ab6";